import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'navigation-shortcuts.edit-shortcut-modal.flags.delete.title',
		defaultMessage: 'Link removed',
		description: '',
	},
	description: {
		id: 'navigation-shortcuts.edit-shortcut-modal.flags.delete.description',
		defaultMessage: 'You have removed the link successfully.',
		description: '',
	},
});
